import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { ApliableTreeCheckbox } from './ApliableTreeCheckbox';
import { OutlinedCustomCard } from "./OutlinedCustomCard";

const MetadataApliableFilterCard = React.memo((props) => {
  const {
    cardTitle,
    metadataList,
    controlSettings,
    setApliableFilterList,
    checkedList,
    setCheckedList,
    isAsset
  } = props;

  const theme = useTheme();

  /**
   * フィルターチェックボックスクリック時イベント
   * @param {any} checked チェックしたId
   */
  const handleFilterChange = (checked) => {
    setCheckedList(checked);
    // 2024.5.8 MyMine Version1.5対応 Add Start
    setApliableFilterList(checked);
    // 2024.5.8 MyMine Version1.5対応 Add End
  };

  /** ClearAllボタンクリック時イベント */
  const handleClearAllButton = () => {
    setApliableFilterList([]);
  };

  return (
    <OutlinedCustomCard>
      <CardHeader
        sx={{ display: 'flex', background: theme.palette.background.secondary, height: isAsset ? '9.2%' : '10%' }}
        title={<MyMLabel sx={{ color: 'white' }}>{cardTitle}</MyMLabel>}
      />
      <CardContent sx={{ height: isAsset ? 570 : 590, '&:last-child': { paddingBottom: 0 } }}>
        <ApliableTreeCheckbox
          needsCascade={true}
          treeItemList={metadataList}
          checkedList={checkedList}
          setChecked={handleFilterChange}
          clearText={controlSettings.LabelList.btnClearAll}
          handleClearAll={handleClearAllButton}
          isShrink={true}
          isAsset={isAsset}
        />
      </CardContent>
    </OutlinedCustomCard>
  );
})
export default MetadataApliableFilterCard;